import styled from 'styled-components';
import NewLocationIcon from '../../../../new-components/svg-icons/NewLocationIcon';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import CardDescription from './CardDescription';
import Logo from '../../../../new-components/ui/Logo';

interface CardHeaderProps {
  area?: string;
  name: string;
  developerLogo?: string;
  propertyType?: string;
  compound?: string;
  description: string;
}
const CardHeader = ({
  area,
  name,
  developerLogo,
  propertyType,
  compound,
  description
}: CardHeaderProps) => {
  const isMobile = useSelector((state: any) => state.app.isMobile);

  const getCardName = useCallback(() => {
    return propertyType && compound ? `${propertyType}, ${compound}` : name;
  }, [propertyType, compound]);

  return (
    <Container>
      <div className="entity-info">
        {!isMobile && (
          <div className="area">
            <span>
              <NewLocationIcon />
            </span>

            {area}
          </div>
        )}
        <div className="name">{getCardName()}</div>

        {isMobile && <CardDescription description={description} />}
      </div>

      {developerLogo && (
        <div className="logo">
          <Logo logoPath={developerLogo} />
        </div>
      )}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  .entity-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-width: 90%;
    .area {
      display: flex;
      gap: 4px;
      color: #5b6573;
      font-size: 12px;
      font-family: materialRegular;
    }

    .name {
      color: #1a2028;
      font-size: 17px;
      font-family: materialBold;
    }
  }

  .logo {
    position: relative;
    div {
      border-radius: 4px !important;
      background-color: transparent;
    }
    .logo-wrapper {
      width: 43px;
      height: 43px;
      .img-wrapper {
        width: 100%;
        height: 100%;
      }
    }
  }

  @media (max-width: ${props => props.theme.breakPoints.mobile.max}) {
    .entity-info {
      max-width: 80%;
    }
  }
`;

export default CardHeader;
